import React from "react";
import "./EndFryRight.css";

import { useNavigate } from "react-router-dom";
const EndFryRight = () => {
  const navigate = useNavigate();
  return (
    <div className="end-component">
     <img src="https://all-frontend-assets.s3.amazonaws.com/fryright_images/round+4.webp" className="hierimhg" alt="#" />
      <h1 className="end-header">
        {" "}
        What the Fry Right System Brings to Your Kitchen{" "}
        <img src="https://all-frontend-assets.s3.amazonaws.com/fryright_images/yellow+headerimg.webp" style={{ float: "right",marginTop:"-10px" }} alt="#" />
      </h1>
      <div className="textarea1">
        <div className="textarea">
          <ul>
            <li style={{ marginBottom: "30px" }}>
              The Fry Right System is a complete solution for improving fried
              food quality and oil cycle longevity. From start to finish, our
              team will be there to help train and consult your staff to get the
              longest Quality Cycle<sup className=" TM">TM &nbsp;</sup>  possible.
              Dozens of kitchens have gone from dirty fryers, unhappy employees
              and unsatisfied or sick customers to{" "}
              <strong>
                satisfied customers, happy employees, and clean fryers with
                ease.
              </strong>{" "}
              This will positively impact your kitchen, which will keep your
              customers coming back for more!
            </li>
            <li>
              Customers will put up with bad service for great food, but will
              not appreciate great service with bad food. The Fry Right System’s
              Quality Cycle<sup className=" TM">TM &nbsp;</sup>  will change the culture
              of your kitchen concerning fried food.
            </li>
          </ul>
        </div>
        <img src="https://all-frontend-assets.s3.amazonaws.com/fryright_images/round+4.webp" alt="#" />
      </div>

      <div className="textarea2">
        <img src="https://all-frontend-assets.s3.amazonaws.com/fryright_images/round5.webp" alt="#" />
        <div className="textarea">
          <h2>What does the Fry Right System bring to the table? </h2>
          <ul>
            <li>
              {" "}
              <p className="list-no">1</p>{" "}
              <p className="list-text">
                {" "}
                Complete Quality Cycle<sup className=" TM">TM &nbsp;</sup>  tracking
                system to monitor TPM growth and Top Off usage.
              </p>
            </li>
            <li>
              <p className="list-no">2</p>{" "}
              <p className="list-text"> Required Tools and System Stickers.</p>
            </li>
            {/* <li>
              <p className="list-no">3</p>{" "}
              <p className="list-text">
                {" "}
                Ability to easily enter and review location specific Quality
                Cycle<sup className=" TM">TM &nbsp;</sup>  data from any device.
              </p>
            </li> */}
            <li>
              <p className="list-no">3</p>{" "}
              <p className="list-text">
                {" "}
                On-site training system to support management with new hire
                employees who need to perform the correct Quality Cycle
                <sup className=" TM">TM &nbsp;</sup>
                management protocols.
              </p>
            </li>
            <li>
              <p className="list-no"> 4</p>{" "}
              <p className="list-text">
                {" "}
                Support provided by Fry Right Professionals, The Fry Right
                System(website|app) and Fry Right System Certified Operators.{" "}
              </p>
            </li>
          </ul>
          <button onClick={()=>navigate("/contact")} >
            Ask us how you can become a Fry Right System Certified Operator!
          </button>
        </div>
      </div>
    </div>
  );
};

export default EndFryRight;
